// extracted by mini-css-extract-plugin
module.exports = {"PageHeader":"PageHeader_PageHeader__3pcNU"};